import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { KeyValueBlockModule, TimeAgoPipeModule } from "ngx-zcs-components";
import { MatIconModule } from '@angular/material/icon';

import { BlockTitleComponent } from '../components/block-title/block-title.component';
import { HeatpumpFlowChartComponent } from './heatpump-flow-chart.component';
import { CelsiusTemperaturePipe } from '../pipes/celsius-temperature.pipe';

@NgModule({
  declarations: [
    HeatpumpFlowChartComponent,
  ],
  exports: [
    HeatpumpFlowChartComponent,
  ],
  imports: [
    BlockTitleComponent,
    CelsiusTemperaturePipe,
    CommonModule,
    IonicModule,
    KeyValueBlockModule,
    MatIconModule,
    TimeAgoPipeModule
  ]
})
export class HeatpumpFlowChartModule { }
